import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  IllustrationImageComponent,
  IllustrationImageName,
} from '@libs/shared/ui/illustration-image/illustration-image.component';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [IllustrationImageComponent, NgClass],
  template: `
    <div class="flex flex-col items-center">
      @if (imageName) {
        <app-illustration-image
          [imageName]="imageName"
          [size]="size"
          [ngClass]="{
            'py-2': size === 'sm',
            'py-4': size === 'md',
            'py-6': size === 'lg',
            'py-8': size === 'xl',
          }" />
      }
      <div class="flex flex-col">
        <div
          class="text-center font-bold"
          [ngClass]="{
            'text-md': size === 'sm',
            'text-lg': size === 'md',
            'text-xl': size === 'lg',
            'text-2xl': size === 'xl',
          }"
          [innerHtml]="title"></div>
        <div
          class="text-secondary text-center"
          [ngClass]="{
            'text-sm': size === 'sm',
            'text-md': size === 'md',
            'text-lg': size === 'lg' || size === 'xl',
          }"
          [innerHtml]="description"></div>
      </div>
      <div class="flex flex-col items-center">
        <ng-content />
      </div>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStateComponent {
  @Input() imageName: IllustrationImageName;
  @Input({ required: true }) title: string;
  @Input() description: string;
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' = 'md';

  constructor() {}
}
